import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    id: string,
    title: string,
}

interface Variables {
    input: {
        code: string,
        description: string,
        price: number,
        title: string,
    }
}

export const CREATE_PACKAGE: TypedDocumentNode<Result, Variables> = gql`
    mutation CreatePackage($input: CreatePackageInput){
        createPackage(input: $input) {
            id
            title
        }
    }       
`
